import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6667 17.5001V10.8334C16.6667 10.3914 16.4911 9.96746 16.1786 9.6549C15.866 9.34234 15.4421 9.16675 15 9.16675H5.00004C4.55801 9.16675 4.13409 9.34234 3.82153 9.6549C3.50897 9.96746 3.33337 10.3914 3.33337 10.8334V17.5001"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33337 13.3333C3.33337 13.3333 3.75004 12.5 5.00004 12.5C6.25004 12.5 7.08337 14.1667 8.33337 14.1667C9.58337 14.1667 10.4167 12.5 11.6667 12.5C12.9167 12.5 13.75 14.1667 15 14.1667C16.25 14.1667 16.6667 13.3333 16.6667 13.3333"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66663 17.5H18.3333"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83337 6.66675V9.16675"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.66675V9.16675"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 6.66675V9.16675"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83337 3.33325H5.84171"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.33325H10.0083"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 3.33325H14.175"
        stroke="#e7212b"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
